import { useI18n } from "hooks/i18n/i18n";
import { convertBrToLineBreakCode } from "utility/convertBrTo";

import { getDatetimeDisplay } from "./functions/getDatetimeDisplay";

import type { Props } from "./props";

type Input = Props;

export const useThis = (input: Input) => {
  const { eventOpenTime, title } = input;
  const { t } = useI18n();
  const { dateDisplay, dateForTimeAttribute, dayDisplay, timeDisplay } =
    getDatetimeDisplay(eventOpenTime, t);
  const convertedTitle = convertBrToLineBreakCode(title);

  return {
    convertedTitle,
    dateDisplay,
    dateForTimeAttribute,
    dayDisplay,
    timeDisplay,
  };
};
